export default{
    camino: null,
    caminos: [],
    agencias: [],
    agencia: null,
    languages: ["ES", "EN", "DE"],
    languageSelected: "es",
    
}